import { render } from "./ExhibitorEditPage.vue?vue&type=template&id=ef18b892&scoped=true"
import script from "./ExhibitorEditPage.vue?vue&type=script&lang=js"
export * from "./ExhibitorEditPage.vue?vue&type=script&lang=js"

import "./ExhibitorEditPage.vue?vue&type=style&index=0&id=ef18b892&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef18b892"]])

export default __exports__